import React from 'react'
import { Row, Col, Divider } from 'antd'
import IntlMessages from '../util/IntlMessages'
import _ from 'lodash'
import {
  isEmptyObject,
  getDecryptID,
  formatDigits,
  customParse,
  parseFloatCustom,
  parseIntCustom,
  fetchCurrentSalesOrder
} from '../appRedux/actions/GlobalMethods'
import Barcode from 'react-barcode'
import moment from 'moment'
import {
  PRINT_CASH_MOVE_TYPES,
  PRINT_CONST_FOOTER_1,
  PRINT_CONST_FOOTER_2,
  // REACT_APP_PRINT_CONST_FOOTER_3,
  PRINT_TYPES
} from '../constants/StoreSetting'
import { env } from '../env'

const { REACT_APP_PRINT_CONST_FOOTER_3 } = env

export class OpenClosePrint extends React.PureComponent {
  render () {
    const { outletName, registerName, storeInfo } = this.props
    const decimal = this.props.decimal ? this.props.decimal : 2
    const data = this.props.data ? this.props.data : false
    const currData = this.props.currData
      ? this.props.currData
      : {
          currencyCode: ''
        }
    const today = moment().format('LLLL')
    return (
      <>
        {data ? (
          <div className='custom-print-outer-layout'>
            <div>
              {storeInfo && storeInfo.storeName && (
                <Row justify='center' style={{ marginBottom: 10 }}>
                  <Col>
                    <h3 className='reciept-font-size'>{storeInfo.storeName}</h3>
                  </Col>
                </Row>
              )}
              <Row justify='center'>
                <Col>
                  <h3 className='reciept-font-size'>{today}</h3>
                </Col>
              </Row>

              <Divider dashed={true} style={{ backgroundColor: 'black' }} />

              {data.type && (
                <>
                  <Row justify='center'>
                    <Col>
                      <h1 className='reciept-font-size'>
                        {data.type == PRINT_TYPES.opening
                          ? 'Opening Float'
                          : data.type == PRINT_TYPES.cashMove
                          ? `${
                              data.cashType == PRINT_CASH_MOVE_TYPES.CASH_IN
                                ? 'CASH IN'
                                : data.cashType ==
                                  PRINT_CASH_MOVE_TYPES.CASH_OUT
                                ? 'CASH OUT'
                                : data.cashType ==
                                  PRINT_CASH_MOVE_TYPES.PETTY_CASH_IN
                                ? 'PETTY CASH IN'
                                : data.cashType ==
                                  PRINT_CASH_MOVE_TYPES.PETTY_CASH_OUT
                                ? 'PETTY CASH OUT'
                                : ''
                            }`
                          : ''}
                      </h1>
                    </Col>
                  </Row>
                  <Row justify='center'>
                    <Col>
                      <h1 className='reciept-font-size'>{`${
                        currData.currencySymbol
                      } ${
                        data.amount
                          ? formatDigits(data.amount, decimal)
                          : '0.00'
                      }`}</h1>
                    </Col>
                  </Row>
                  <Divider dashed={true} style={{ backgroundColor: 'black' }} />
                </>
              )}

              {data.outlet && (
                <Row justify='center'>
                  <Col span={12}>
                    <h3 className='reciept-font-size'>Outlet</h3>
                  </Col>

                  <Col span={12}>
                    <h3
                      style={{ textAlign: 'center' }}
                      className='reciept-font-size'
                    >
                      {data.outlet}
                    </h3>
                  </Col>
                </Row>
              )}

              {data.register && (
                <Row justify='center'>
                  <Col span={12}>
                    <h3 className='reciept-font-size'>Register</h3>
                  </Col>

                  <Col span={12}>
                    <h3
                      style={{ textAlign: 'center' }}
                      className='reciept-font-size'
                    >
                      {data.register}
                    </h3>
                  </Col>
                </Row>
              )}

              {data.date && (
                <Row justify='center'>
                  <Col span={12}>
                    <h3 className='reciept-font-size'>Date</h3>
                  </Col>

                  <Col span={12}>
                    <h3
                      style={{ textAlign: 'center' }}
                      className='reciept-font-size'
                    >
                      {moment(data.date).format('l LT')}
                    </h3>
                  </Col>
                </Row>
              )}

              {data.user && (
                <Row justify='center'>
                  <Col span={12}>
                    <h3 className='reciept-font-size'>User</h3>
                  </Col>

                  <Col span={12}>
                    <h3
                      style={{ textAlign: 'center' }}
                      className='reciept-font-size'
                    >
                      {data.user}
                    </h3>
                  </Col>
                </Row>
              )}

              {data.note && (
                <Row justify='center'>
                  <Col span={12}>
                    <h3 className='reciept-font-size'>Note</h3>
                  </Col>

                  <Col span={12}>
                    <h3
                      style={{ textAlign: 'center' }}
                      className='reciept-font-size'
                    >
                      {data.note}
                    </h3>
                  </Col>
                </Row>
              )}

              <div style={{ marginTop: 32 }}>
                <h2
                  className='reciept-font-size'
                  style={{ textAlign: 'center' }}
                >
                  <strong>{PRINT_CONST_FOOTER_1}</strong>
                </h2>
                <h3
                  className='reciept-font-size'
                  style={{ textAlign: 'center' }}
                >
                  {PRINT_CONST_FOOTER_2}
                </h3>
                <h3
                  className='reciept-font-size'
                  style={{ textAlign: 'center' }}
                >
                  {REACT_APP_PRINT_CONST_FOOTER_3}
                </h3>
              </div>
            </div>
          </div>
        ) : (
          <h1>
            <IntlMessages id='sell.openclose.connectionlost' />
          </h1>
        )}
      </>
    )
  }
}
